export * from '@fluentui/theme/lib/effects/FluentDepths';
